<template>
    <Administrative>
        <!--        {{ menus }}-->
        <Page :submenus="menus"/>
        <div class="-mt-4">
            <BreadcrumbsComponent :pages="pages" :is-dashboard="false">
                <a v-if="presentation" class="col-span-2 inline-flex
                            items-center px-4 py-2 bg-gray-800
                            border border-transparent rounded-md
                            font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
                            active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                   :href="presentation?.file" target="_blank"
                >
                    View Referral document
                </a>
            </BreadcrumbsComponent>
            <div class="grid gap-4 grid-cols-9 -mt-4">

                <div class="col-span-4">


                    <Table :fields="fields"
                           :items="presentations"
                           :canView="true"
                           :empty_message="`${_type} not found`"
                    >
                        <template #total="{item}">
                            {{ item.done_marking }} / {{ item.total_students }}
                        </template>
                        <template #action="{item}">
                            <inertia-link
                                :href="`${route(`administrative.faculty.view.${type}`, [item.faculty.id, branch.id])}?course=${course_year.id}&item=${item.id}`">
                                <Button>
                                    View
                                </Button>
                            </inertia-link>
                        </template>
                    </Table>
                </div>

                <div class="col-span-5" v-if="presentation">


                    <Table :fields="studentsFields"
                           :items="students"
                           :canView="true"
                           :empty_message="`Students not found`"
                    >
                        <template #remoark="{item}">
                            <div v-if="item?.submission">
                                {{ item.submission?.remark }}
                            </div>
                            <p v-else>-</p>
                        </template>
                        <template #marks="{item}">
                            <div v-if="item?.submission">
                                {{ item.submission?.marks }} / {{ presentation.total_marks }}
                            </div>
                            <p v-else>-</p>
                        </template>
                        <template #name="{item}">
                            <div>
                                {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                                <p v-if="item?.submission" class="text-green-600 text-sm mt-1">Submitted on
                                    {{ tableDate(item?.submission?.created_at) }}</p>
                                <p v-else class="text-red-600 text-sm mt-1">Not submitted yet</p>
                            </div>
                        </template>
                        <template #action="{item}">
                            <div class="flex gap-2">
                                <a v-if="item?.submission" class="col-span-2 inline-flex
                            items-center px-4 py-2 bg-gray-800
                            border border-transparent rounded-md
                            font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
                            active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                                   :href="item?.submission?.file" target="_blank"
                                >View

                                </a>
                                <Button v-else disabled="true">
                                    View
                                </Button>

                                <inertia-link
                                    :href="`${route(`internal.admission.view`, [branch.id, item?.admission?.id])}?activeTab=Performance`">
                                    <Button>Performance</Button>
                                </inertia-link>
                            </div>
                        </template>
                    </Table>

                </div>
            </div>
        </div>
    </Administrative>
</template>
<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import Administrative from "@/Pages/Administrative/Administrative.vue";
import {computed} from "vue";
import {tableDate} from "../../../../../Utils/Common";
import {capitalize} from "@vue/shared";
import Page from '@/Components/Page'
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";

const presentations = usePage().props.value.presentations ?? [];
const course_years = usePage().props.value.course_years ?? [];
const course_year = usePage().props.value?.course_year ?? null;
const branch = usePage().props.value?.branch ?? {};
const presentation = usePage().props.value?.presentation ?? null;
const type = usePage().props.value?.type ?? null;
const faculty = usePage().props.value?.faculty ?? null;

const _type = computed(() => `${capitalize(type)}${type == 'bonus' ? '' : 's'}`)
const students = computed(() => {
    let _students = presentation?.submitted_students ?? [];
    _students = _students.map((item) => {
        const {student, ...rest} = item;
        return {...student, submission: rest};
    })
    return [..._students, ...presentation.not_submitted_students];
})
const fields = [
    {'key': 'title', 'label': 'title'},
    {'key': 'total', 'label': 'Submitted / Total Students'},
    {'key': 'action', 'label': 'Action'}
];

const studentsFields = [
    {'key': 'name', 'label': 'Student'},
    {'key': 'roll_no', 'label': 'Roll No'},
    {'key': 'marks', 'label': 'Marks'},
    {'key': 'remoark', 'label': 'Remark'},
    {'key': 'action', 'label': 'Action'}
];
const menus = computed(() => {
    return course_years.map((item) => {
        return {
            'title': `${item.title}-${item.course.title}`,
            'active': (course_year.id === item.id),
            'route': `${route(`administrative.faculty.view.${type}`, [faculty.id, branch.id])}?course=${item.id}`,
            'visible': true
        };
    })
})
const pages = [
    {name: 'Faculties', href: route('administrative.faculty.list'), current: false},
    {
        name: ` ${faculty.first_name} ${faculty.last_name}`,
        href: route('administrative.faculty.view', faculty.id),
        current: false
    },
    {
        name: _type?.value,
        href: presentation ? route(`administrative.faculty.view.${type}`, [faculty.id, branch.id]) : '',
        current: true
    },
    {name: presentation?.title, current: true},
]
// presentation.title
</script>
